
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

import Anchor from '@/elements/anchor/Anchor.vue';
import Message from '@/components/message/Message.vue';
import { AreaPermit } from '@/store/types';

export default defineComponent({
  name: 'PermitLookupResult',
  components: { Anchor, Message },
  props: {
    permit: {
      type: Object as () => AreaPermit,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    return {
      t,
      licensePlate: props.permit.licensePlate,
      zone: props.permit.zone,
      capitalize: (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
      },
      summary: computed(() =>
        props.permit.isValid
          ? t('permitFoundHeader', { licensePlate: props.permit.licensePlate })
          : t('permitNotFoundHeader', {
              licensePlate: props.permit.licensePlate,
            })
      ),
    };
  },
});
